import { useEffect, useState } from 'react'
import { useAxios } from '../core/AxiosContext'
import { useGlobal } from '../core/GlobalContext'
import { fetchPortfolioAction } from '../routes/portfolio/PortfolioDuck'
import jsonParse from '../utils/jsonapi'
import { portfolioParser } from '../utils/portfolio/portfolioParsers'

const useOrdersToDisplay = (query, pageNumber, portfolioType) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [orders, setOrders] = useState([])
  const [hasMore, setHasMore] = useState(false)

  const { authAxios } = useAxios()
  const {
    financierState: { financier },
  } = useGlobal()

  // Custom IndexOf function similar to ==
  const myIndexOf = (arr, o) => {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].dealTransactionCode == o.dealTransactionCode) {
        return i
      }
    }
    return -1
  }

  useEffect(() => {
    setOrders([])
    setHasMore(false)
    setLoading(true)
  }, [portfolioType])

  const fetchOrdersToDisplay = (controller, pageNumber, query = '') => {
    const params = {
      // Logic of resetting and incrementing nextPage is done in Duck
      page: pageNumber,
      financier_id: financier?.financierPAN,
      state: portfolioType,
      search: query,
      order_by: 'created_at',
    }
    fetchPortfolioAction(params, controller)(authAxios)(res => {
      const apiResponse = jsonParse(res).data
      const meta = res.meta
      const parsedData = apiResponse?.map(portfolio => portfolioParser(portfolio))
      setOrders(prevItems => prevItems.concat(parsedData.filter(item => myIndexOf(prevItems, item) < 0)))
      setHasMore(Boolean(meta?.next))

      setLoading(false)
    }, setError(true))
  }

  useEffect(() => {
    setOrders([])
  }, [query])

  useEffect(() => {
    // Guard: don't fetch until the financier PAN is loaded, otherwise the request
    // goes out to `/api/v1/financiers/undefined/orders`. Re-runs once PAN is present.
    if (!financier?.financierPAN) {
      setLoading(true)
      return
    }
    setLoading(true)
    setError(false)
    const controller = new AbortController()
    fetchOrdersToDisplay(controller, pageNumber, query)

    return () => {
      controller.abort()
    }
  }, [pageNumber, portfolioType, query, financier?.financierPAN])

  return { orders, hasMore, loading, error }
}

export default useOrdersToDisplay
